import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useGiveawayStore from '@/stores/GiveawayStore';
import SettingsPanel from '../SettingsPanel';
import { useShallow } from 'zustand/react/shallow';
import styles from './GiveawayActiveStep.module.scss';
import { NativeSelect, Switch, Text } from '@mantine/core';
import GiveawayCreateFooter from './GiveawayCreateFooter';
import GiveawayWinnerMessageSetting from './GiveawayWinnerMessageSetting';
import GiveawayLuckSettings from './GiveawayLuckSettings';
export default function GiveawayActiveStep(param) {
    var onBack = param.onBack, onNext = param.onNext;
    var intl = useIntl();
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            activityTimeout: state.activityTimeout,
            setActivityTimeout: state.setActivityTimeout,
            uniqueWinners: state.uniqueWinners,
            setUniqueWinners: state.setUniqueWinners
        };
    })), setActivityTimeout = _useGiveawayStore.setActivityTimeout, activityTimeout = _useGiveawayStore.activityTimeout, uniqueWinners = _useGiveawayStore.uniqueWinners, setUniqueWinners = _useGiveawayStore.setUniqueWinners;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.subHeading,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "pNPUaU",
                    defaultMessage: "Configure the settings for the giveaway."
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                className: styles.settingsPanel,
                afterElementContainerProps: {
                    className: styles.numberInput
                },
                heading: intl.formatMessage({
                    id: "Hsh/Ta",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Activity Timeout"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "sam5J8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Minimum time a user must be active to be eligible for the giveaway."
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsxs(NativeSelect, {
                    variant: "outline",
                    value: activityTimeout,
                    onChange: function(e) {
                        return setActivityTimeout(parseInt(e.target.value, 10));
                    },
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: 1,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "k++se8",
                                defaultMessage: "1 minute"
                            })
                        }),
                        /*#__PURE__*/ _jsx("option", {
                            value: 5,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "++FVOV",
                                defaultMessage: "5 minutes"
                            })
                        }),
                        /*#__PURE__*/ _jsx("option", {
                            value: 10,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "CNaG5S",
                                defaultMessage: "10 minutes"
                            })
                        }),
                        /*#__PURE__*/ _jsx("option", {
                            value: 15,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "W4YHJM",
                                defaultMessage: "15 minutes"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                className: styles.settingsPanel,
                heading: intl.formatMessage({
                    id: "UnFLxJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Unique Winners"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    checked: uniqueWinners,
                    onChange: function(e) {
                        return setUniqueWinners(e.target.checked);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(GiveawayWinnerMessageSetting, {}),
            /*#__PURE__*/ _jsx(GiveawayLuckSettings, {}),
            /*#__PURE__*/ _jsx(GiveawayCreateFooter, {
                backButtonProps: {
                    onClick: onBack
                },
                nextButtonProps: {
                    onClick: onNext
                },
                nextText: intl.formatMessage({
                    id: "JXdbo8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Done"
                        }
                    ]
                })
            })
        ]
    });
}
